/* eslint-disable max-len */
import React, { FC, useMemo, useState } from 'react'
import Tips from '../common/Tips'
import { secToHourMinute } from '../../../utils/date'
import SvgPieChart from './SvgPieChart'

interface GraphItem {
  label: string
  color: string
  value: number
}

interface Props {
  title: string
  graphItems: GraphItem[]
  legendSquare?: boolean
}

const LabelingPie: FC<Props> = (props) => {
  const {
    title,
    graphItems,
    legendSquare,
  } = props

  const [hoverName, setHoverName] = useState<string>("")

  const totalTime = useMemo(() => {
    if (!graphItems) return 0
    return graphItems.reduce((s, w) => s + w.value, 0)
  }, [graphItems])

  const onMouseOverGraph = (name: string) => {
    setHoverName(name)
  }

  const onMouseLeaveGraph = () => {
    setHoverName("")
  }

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "calc(50% - 12px)",
          border: "solid 1px #999999",
          borderRadius: "4px",
          padding: "16px",
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        {
          !!title && (
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "4px",
                transform: "translateY(-50%)",
                backgroundColor: "#FFFFFF",
                fontSize: "10px",
                color: "#666666",
                padding: "0 4px",
              }}
            >
              {title}
            </div>
          )
        }
        <SvgPieChart
          list={graphItems}
          graphTitle={title}
          chartSize={150}
          hoverName={hoverName}
        />
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "8px",
            overflowY: "scroll",
            width: "100%",
            maxHeight: "150px",
          }}
        >
          {
            graphItems.length === 1 && !graphItems[0].value ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "150px",
                    color: "#999999",
                    fontSize: "16px",
                  }}
                >
                  データがありません
                </div>
              </>
            ) : (
              <>
                {
                  graphItems.map((v) => (
                    <div
                      key={`pie_legend_${v.label}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "4px",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onMouseOver={() => onMouseOverGraph(v.label)}
                      onFocus={() => { /* */ }}
                      onMouseLeave={() => onMouseLeaveGraph()}
                      role="none"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "12px",
                            minHeight: "12px",
                            backgroundColor: v.color,
                            borderRadius: legendSquare ? "0" : "50%",
                          }}
                        />
                        {v.label}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {secToHourMinute(v.value)}
                        </div>
                        <div
                          style={{
                            fontSize: "10px",
                          }}
                        >
                          {`(${Math.floor((v.value / totalTime) * 1000) / 10}%)`}
                        </div>
                      </div>
                    </div>
                  ))
                }
              </>
            )
          }
        </div>
      </div>
    </>
  )
}

LabelingPie.defaultProps = {
  legendSquare: false,
}

export default LabelingPie
